import React, { FC, useMemo, useState } from 'react';
import classNames from 'classnames';
import ReorderResizeTable from 'components/ReorderResizeTable';
import { ColumnFilterOption } from 'components/ReorderResizeTable/types';
import {
  COLUMNS,
  CUSTOM_COL_SIZES,
  HEADING_TRANSLATIONS,
  SORTING_VALUES,
  SuggestedActionsTableData,
  BODY_CONTENT_GENERATE,
} from './data';
import SuggestedActionsDrawer from '../SuggestedActionsDrawer';
import useCallbackRef from 'hooks/useCallbackRef';
import { SideDrawerRef } from 'router/subrouters/DataRoom/components/SideDrawer/SideDrawer.component';

import './SuggestedActionsTable.styles.scss';

type SuggestedActionsTableProps = {
  className?: string;
  isLoading?: boolean;
  isDragDisabled?: boolean;
  totalPages?: number;
  data: SuggestedActionsTableData[];
  columnFilterOptions?: Record<string, ColumnFilterOption>;
};

const SuggestedActionsTable: FC<SuggestedActionsTableProps> = (props) => {
  const {
    className,
    isLoading,
    isDragDisabled = true,
    totalPages = 1,
    data,
    columnFilterOptions,
  } = props;

  const [selectedSuggestedAction, setSelectedSuggestedAction] =
    useState<SuggestedActionsTableData>();

  const [drawer, drawerRef] = useCallbackRef<SideDrawerRef>();

  const classes = classNames('suggested-actions-table', className);

  const tableContentTransformations = useMemo(
    () =>
      COLUMNS.reduce(
        (acc, col) => ({
          ...acc,
          [col]: (data: SuggestedActionsTableData) =>
            BODY_CONTENT_GENERATE[col]({
              data,
            }),
        }),
        {},
      ),
    [],
  );

  return (
    <>
      <ReorderResizeTable
        className={classes}
        isDragDisabled={isDragDisabled}
        totalPages={totalPages}
        data={data}
        columns={COLUMNS}
        headingTranslations={HEADING_TRANSLATIONS}
        sortingValues={SORTING_VALUES}
        isDataLoading={isLoading}
        tableContentTransformations={tableContentTransformations}
        customSizes={CUSTOM_COL_SIZES}
        columnFilterOptions={columnFilterOptions}
        onRowClick={(suggestedAction) => {
          setSelectedSuggestedAction(suggestedAction);
          drawer?.setOpen(true);
        }}
      />

      <SuggestedActionsDrawer
        ref={drawerRef}
        suggestedAction={selectedSuggestedAction}
      />
    </>
  );
};

export default SuggestedActionsTable;
